import React, { useState } from 'react'
import { Blacked, DBModalContent, DBModalInput, DBModalInputLine, DBModalInputWrap, ModalContent, ModalHeader, ModalInput, ModalSubmit, ModalTitle, ModalWrapper } from '../styles';
import { Icon } from 'CRM/organism/Main/styles';
import { FaChevronLeft } from 'react-icons/fa6';
import { Checkbox, Input, Select, message } from 'antd'
import { ChromePicker } from 'react-color';
import API from 'utils/api';
import { useToken } from 'app/hooks';
import { usePathList } from 'CRM/hooks/GetPathList';
import { useBranchList } from 'CRM/hooks/GetBranchList';
import { useFilterList } from 'CRM/hooks/GetFilterList';
import {useIsMobile} from "../IsMobile";

export const EmployeeAdd = ({ setIsAdd, mutate }) => {
  const IsMobile = useIsMobile();
  const { data: token } = useToken();
  const { branchList } = useBranchList();
  const { filterList: teamList } = useFilterList('team');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [passwordRe, setPasswordRe] = useState('');
  const [email, setEmail] = useState('');
  const [tel, setTel] = useState('');
  const [memo, setMemo] = useState('');
  const [branch, setBranch] = useState('');
  const [team, setTeam] = useState('');

  const [leader, setLeader] = useState(false);
  const [admin, setAdmin] = useState(false);

  const clickSubmit = () => {
    const shouldEdit = window.confirm(`직원을 등록하시겠습니까?`);
    if(shouldEdit) {
      if(name == '') {
        message.error('이름은 필수 입력입니다.')
      } else if (password !== passwordRe) {
        message.error('비밀번호가 일치하지 않습니다.')
      } else {
        API.post('/admin', token + '', {
          name: name,
          email: email,
          password: password,
          tel: tel,
          memo: memo,
          branchId: branch,
          teamId: team,
          admin: admin,
          leader: leader
        })
        .then((res: any) => {
          if (res.result.success) {
            message.success('추가되었습니다');
            mutate();
            setIsAdd(false);
          }
        })
        .catch((err: any) => {})
      }
    }
  }

  return (
    <>
      <Blacked onClick={() => setIsAdd(false)} />
      {IsMobile ?
        <ModalWrapper IsMobile={IsMobile}>
          <ModalHeader>
            <Icon onClick={() => setIsAdd(false)}><FaChevronLeft /></Icon>
            <ModalTitle>본사직원 등록</ModalTitle>
            <ModalSubmit onClick={clickSubmit}>등록</ModalSubmit>
          </ModalHeader>
          <DBModalContent>
            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>이름 *</label>
                <DBModalInputWrap>
                  <Input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder='이름을 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>

            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>연락처</label>
                <DBModalInputWrap>
                  <Input type="text" value={tel} onChange={(e) => setTel(e.target.value)} placeholder='연락처를 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>

            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>비밀번호</label>
                <DBModalInputWrap>
                  <Input type="text" value={password} onChange={(e) => setPassword(e.target.value)} placeholder='비밀번호를 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>

            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>비밀번호 확인</label>
                <DBModalInputWrap>
                  <Input type="text" value={passwordRe} onChange={(e) => setPasswordRe(e.target.value)} placeholder='비밀번호 확인' />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>

            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>팀</label>
                <DBModalInputWrap>
                  <Select value={team} onChange={(e) => setTeam(e)}>
                    <option style={{ fontFamily: 'Pretendard' }} value={''}>없음</option>
                    {teamList?.map(it => (
                      <option style={{fontFamily: 'Pretendard'}} value={it.id}>{it.name}</option>
                    ))}
                  </Select>
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>

            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>아이디</label>
                <DBModalInputWrap>
                  <Input type="text" value={email} onChange={(e) => setEmail(e.target.value)} placeholder='아이디를 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>

            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>메모</label>
                <DBModalInputWrap>
                  <Input type="text" value={memo} onChange={(e) => setMemo(e.target.value)} placeholder='메모를 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>

            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>관리자</label>
                <DBModalInputWrap>
                  <Checkbox checked={admin} onChange={(e) => setAdmin(e.target.checked)} />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>

            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>팀장</label>
                <Checkbox checked={leader} onChange={(e) => setLeader(e.target.checked)} />
              </DBModalInput>
            </DBModalInputLine>
          </DBModalContent>
        </ModalWrapper>
        :
        <ModalWrapper style={{minHeight: 300}}>
          <ModalHeader>
            <Icon onClick={() => setIsAdd(false)}><FaChevronLeft /></Icon>
            <ModalTitle>본사직원 등록</ModalTitle>
            <ModalSubmit onClick={clickSubmit}>등록</ModalSubmit>
          </ModalHeader>
          <DBModalContent>
            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>이름 *</label>
                <DBModalInputWrap>
                  <Input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder='이름을 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
              <DBModalInput>
                <label style={{padding: 20}}>연락처</label>
                <DBModalInputWrap>
                  <Input type="text" value={tel} onChange={(e) => setTel(e.target.value)} placeholder='연락처를 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>
            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>비밀번호</label>
                <DBModalInputWrap>
                  <Input type="text" value={password} onChange={(e) => setPassword(e.target.value)} placeholder='비밀번호를 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
              <DBModalInput>
                <label style={{padding: 20}}>비밀번호 확인</label>
                <DBModalInputWrap>
                  <Input type="text" value={passwordRe} onChange={(e) => setPasswordRe(e.target.value)} placeholder='비밀번호 확인' />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>
            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>팀</label>
                <DBModalInputWrap>
                  <Select value={team} onChange={(e) => setTeam(e)}>
                    <option style={{ fontFamily: 'Pretendard' }} value={''}>없음</option>
                    {teamList?.map(it => (
                      <option style={{fontFamily: 'Pretendard'}} value={it.id}>{it.name}</option>
                    ))}
                  </Select>
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>
            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>아이디</label>
                <DBModalInputWrap>
                  <Input type="text" value={email} onChange={(e) => setEmail(e.target.value)} placeholder='아이디를 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
              <DBModalInput>
                <label style={{padding: 20}}>메모</label>
                <DBModalInputWrap>
                  <Input type="text" value={memo} onChange={(e) => setMemo(e.target.value)} placeholder='메모를 입력해주세요.' />
                </DBModalInputWrap>
              </DBModalInput>
            </DBModalInputLine>
            <DBModalInputLine>
              <DBModalInput>
                <label style={{padding: 20}}>관리자</label>
                <DBModalInputWrap>
                  <Checkbox checked={admin} onChange={(e) => setAdmin(e.target.checked)} />
                </DBModalInputWrap>
              </DBModalInput>
              <DBModalInput>
                <label style={{padding: 20}}>팀장</label>
                <Checkbox checked={leader} onChange={(e) => setLeader(e.target.checked)} />
              </DBModalInput>
            </DBModalInputLine>
          </DBModalContent>
        </ModalWrapper>
      }
    </>
  )
}

export default React.memo(EmployeeAdd);